var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWallet = function SvgCloseWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "close-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51239",
    transform: "translate(-1164 -333)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20877",
    width: 30,
    height: 30,
    rx: 15,
    transform: "translate(1164 333)",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1180.41 347.999 4.3-4.29a1.004 1.004 0 1 0-1.42-1.42l-4.29 4.3-4.29-4.3a1.004 1.004 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1.004 1.004 0 1 0 1.42 1.42l4.29-4.3 4.29 4.3a1.004 1.004 0 1 0 1.42-1.42Z"
  }))));
};
export default SvgCloseWallet;